/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface GetAdminUsers200ResponseRolesInner
 */
export interface GetAdminUsers200ResponseRolesInner {
    /**
     * 
     * @type {string}
     * @memberof GetAdminUsers200ResponseRolesInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetAdminUsers200ResponseRolesInner
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GetAdminUsers200ResponseRolesInner
     */
    'category': GetAdminUsers200ResponseRolesInnerCategoryEnum;
}

export const GetAdminUsers200ResponseRolesInnerCategoryEnum = {
    system: 'SYSTEM',
    app: 'APP',
    card: 'CARD'
} as const;

export type GetAdminUsers200ResponseRolesInnerCategoryEnum = typeof GetAdminUsers200ResponseRolesInnerCategoryEnum[keyof typeof GetAdminUsers200ResponseRolesInnerCategoryEnum];


